/* eslint-disable unicorn/no-reduce */
/* eslint-disable array-callback-return */
;(function module() {
  angular.module('app.ui.form.ctrls').controller('LocationsModalController', [
    '$uibModalInstance',
    'locationList',
    'selectedLocations',
    'locationsGenericService',
    'limit',
    'logger',
    'locationModalHeading',
    'displayNextButton',
    function controller(
      $uibModalInstance,
      locationList,
      selectedLocations,
      locationsGenericService,
      limit,
      logger,
      locationModalHeading,
      displayNextButton
    ) {
      let vm = this
      /** Setting Location list in this controller scope.
       */
      vm.locationList = angular.copy(locationList)
      vm.regionHierarchialList = locationsGenericService.initialize(
        selectedLocations,
        vm.locationList
      )
      vm.locationModalHeading = locationModalHeading
      vm.displayNextButton = displayNextButton
      vm.regionHierarchialList.sort((a, b) => (a.name > b.name ? 1 : -1))
      vm.regionHierarchialListWithEuropeOnTop = [
        ...vm.regionHierarchialList.filter(region => region.name === 'Europe'),
        ...vm.regionHierarchialList.filter(region => region.name !== 'Europe'),
      ]

      /** This method will expand locations on '+' is clicked
       */
      vm.expandChildLocations = location => {
        location.showLocations = true
      }

      /** This method will collapse locations on '-' is clicked
       */
      vm.collapseChildLocations = location => {
        location.showLocations = false
      }

      /** When clicking 'save' button this method will save only selected child Locations from modal
       */
      vm.save = () => {
        const selectedLocations = locationsGenericService.setIsSelectedChildrenLocation(
          vm.regionHierarchialListWithEuropeOnTop,
          []
        )

        if (selectedLocations.length === 0)
          logger.notify('warning', 'Please select at least one Location.')
        else $uibModalInstance.close(selectedLocations)
      }

      /** When clicking 'cancel' button this method will closed modal
       */
      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }

      /** This method will make selected locations checked or unchecked and make parent and child selected and unselected
       * @param  {} selectedValue selected location from modal
       * @param  {} event modal event of i.e checked or unchecked
       */
      vm.selectLocation = (selectedValue, event) => {
        if (limit > 0) {
          let count = vm.regionHierarchialListWithEuropeOnTop
            .filter(location => location.isSelected)
            .map(region => {
              return region.locations.reduce((locationCount, location) => {
                return locationCount + getSelectedCount([location], false)
              }, 0)
            })
            .reduce((totalCount, eachCount) => totalCount + eachCount, 0)

          locationsGenericService.selectOrDeselectAllLocations(
            [selectedValue],
            true
          )

          count = event.target.checked
            ? selectedValue.children && selectedValue.children.length > 0
              ? count + getSelectedCount([selectedValue], true)
              : selectedValue.locations && selectedValue.locations
              ? count +
                selectedValue.locations.reduce(
                  (locationCount, location) =>
                    locationCount + getSelectedCount([location], true),
                  0
                )
              : count + 1
            : selectedValue.children && selectedValue.children.length > 0
            ? count - getSelectedCount([selectedValue], true)
            : selectedValue.locations && selectedValue.locations
            ? count -
              selectedValue.locations.reduce(
                (locationCount, location) =>
                  locationCount + getSelectedCount([location], true),
                0
              )
            : count - 1

          if (count > limit - 5 && count < limit && count > 0)
            logger.notify(
              'warning',
              'You are approaching the limit for location selections.'
            )
          if (count === limit && count > 1)
            logger.notify(
              'warning',
              ' You have reached the limit for location selections, please refine your expertise to only those locations you have actual experience in.'
            )
          else if (count > limit && count > 0) {
            logger.notify(
              'error',
              `You are allowed to choose a maximum of ${limit} locations.`
            )
            selectedValue.isSelected = false
            event.target.checked = false
          }
        }

        locationsGenericService.selectLocation(
          vm.regionHierarchialListWithEuropeOnTop,
          selectedValue,
          event
        )
      }
    },
  ])
})()

const getSelectedCount = (locations, selected) => {
  return locations.reduce((count, location) => {
    if (location.isSelected || selected) {
      if (location.children && location.children.length > 0) {
        return count + getSelectedCount(location.children, selected)
      }

      count += 1
    }

    return count
  }, 0)
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/locations/locations-modal.ctrl.js